import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import { sleepStoreIsEnabled } from "../../utils/general";
import { ReactComponent as ChevronIcon } from "../../images/chevron-icon.svg";

// Stylesheets
import "./FreeShippingBanner.scss";

// Components
import Link from "./Link";

export const MoonEmoji = () => (
  <span role="img" aria-label="moon">
    &#127769;
  </span>
);

export const FreeShippingBanner = ({ classes, fontClass, isSticky }) => {
  const bannerClass = classNames(
    "free_shipping_banner",
    { is_sticky: isSticky },
    { shop_restore: sleepStoreIsEnabled() },
    classes
  );

  const copyClass = classNames("copy", fontClass);

  let banner = (
    <>
      The all-new Restore launches early May! <MoonEmoji />
    </>
  );

  if (sleepStoreIsEnabled()) {
    banner = (
      <>
        The All-New Hatch Restore is Here!
        <Link className="restore_link" to="/restore">
          Order Now
          <ChevronIcon className="chevron_icon" />
        </Link>
      </>
    );
  }

  return (
    <div className={bannerClass}>
      <h5 className={copyClass}>{banner}</h5>
    </div>
  );
};

FreeShippingBanner.propTypes = {
  classes: PropTypes.any,
  fontClass: PropTypes.any,
  isSticky: PropTypes.bool,
};

FreeShippingBanner.defaultProps = {
  fontClass: "body_secondary",
  isSticky: true,
};

export default FreeShippingBanner;
